import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { withTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./expeditionProcessFilter.data.form";
import InputDate from "../../../utils/InputDate";
import InputText from "../../../utils/InputText";
import InputSelect from "../../../utils/InputSelect";
import { PROCESS_EXPEDITION_STATUS } from "../../../../constants/index";

const ExpeditionProcessFilterForm = (props) => {
  const { t, handleSubmit, filtered, onClean } = props;
  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="outFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.expeditionProcess.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#outFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-6">
                      <div className="row">
                        <div className="col-6">
                          <Field
                            id="dateInit"
                            labelField={t("forms.expeditionProcess.labels.dateInit")}
                            className="form-control"
                            name="dateInit"
                            component={InputDate}
                            language="es"
                            dateFormat="dd/MM/yyyy"
                          />
                        </div>
                        <div className="col-6">
                          <Field
                            id="dateEnd"
                            labelField={t("forms.expeditionProcess.labels.dateEnd")}
                            className="form-control"
                            name="dateEnd"
                            component={InputDate}
                            language="es"
                            dateFormat="dd/MM/yyyy"
                            defaultHours={23}
                            defaultMinutes={59}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-3">
                      <Field
                        id="status"
                        name="status"
                        labelField={t("forms.expeditionProcess.labels.status")}
                        // className="form-control"
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={PROCESS_EXPEDITION_STATUS.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        addOptionEmpty
                        // onChangeValue={onChangeCategory}
                        classNamePrefix="dark"
                        mandatory
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-secondary"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ExpeditionProcessFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onClean: PropTypes.func,
  filtered: PropTypes.bool,
};

const ExpeditionProcessFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ExpeditionProcessFilterForm",
})(withTranslation()(ExpeditionProcessFilterForm));

export default ExpeditionProcessFilterFormF;